import { View, StyleSheet, Image, ImageStyle } from 'react-native';
import React from 'react';
import { hp } from '../helpers/common';
import { theme } from '../constants/theme';
import { getUserImageSrc } from '../services/imageService';
import LazyImage from './LazyImage';

interface AvatarProps {
  uri: string | number;
  size?: number;
  rounded?: number;
  style?: ImageStyle;
}

import defaultUserImg from '../../assets/images/defaultuser.png';

const Avatar: React.FC<AvatarProps> = ({
  uri, 
  size = hp(4.5), 
  rounded = theme.radius.md,
  style = {}
}) => {
  let safeImageUri;
  if (typeof uri === 'string') {
    safeImageUri = uri.trim() !== '' ? getUserImageSrc(uri) : defaultUserImg;
  } else if (typeof uri === 'number') {
    safeImageUri = uri;
  } else {
    safeImageUri = defaultUserImg;
  }
  return (
    <LazyImage 
      source={safeImageUri}
      fallback={defaultUserImg}
      style={[styles.avatar, { height: size, width: size, borderRadius: rounded }, style]}
      resizeMode="cover"
    />
  );
};

const styles = StyleSheet.create({
  avatar: {
    borderColor: theme.colors.darkLight,
    borderWidth: 1,
  },
});

export default Avatar;
